var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app","dir":"rtl"}},[_c('v-app',[_c('AppBar'),_c('NavigationDrawer',{ref:"navigationDrawer"}),_c('v-main',[_c('router-view')],1),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }